import * as React from "react"

import FullStructure from "./FullStructure"
import CondensedStructure from "./CondensedStructure"

interface Props {
    sortedBreadcrumbs: ResourceHeader.BreadcrumbInfo[]
    showCondensed: boolean
}

export const AbsoluteBreadcrumbs = ({
    sortedBreadcrumbs,
    showCondensed,
}: Props): JSX.Element =>
    showCondensed ? (
        <CondensedStructure sortedBreadcrumbs={sortedBreadcrumbs} />
    ) : (
        <FullStructure sortedBreadcrumbs={sortedBreadcrumbs} />
    )

export default AbsoluteBreadcrumbs
